import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'

interface Props {
  isActive: boolean
}

const WebhookStatusCellComponent = ({ isActive }: Props) => {
  if (isActive) {
    return (
      <Chip
        text="Active"
        className={tw`bg-success-200`}
        textClassName={tw`text-success-500`}
        dataTestId="webhook-subscription-status-active"
      />
    )
  }

  return (
    <Chip
      text="Disabled"
      className={tw`bg-shades-100`}
      textClassName={tw`text-shades-500`}
      dataTestId="webhook-subscription-status-disabled"
    />
  )
}

export const WebhookStatusCell = memo(WebhookStatusCellComponent)
